import type { ApolloCache } from '@apollo/client';

import type { DeleteLineItemCustomPacingV5Mutation, LineItemV5 } from '../../apis/graphql';
import { AlertType } from '../../common/Alert';
import { openErrorToastAlert, openToastAlert } from '../../common/ToastAlert/toastAlert';
import { getOldCacheData } from '../../common/utils';
import { CacheEntityIdentifier } from '../../configs/cache';
import { LINE_ITEM_TRAFFICKING_COLUMNS } from '../../pages/Trafficking/TraffickingPage/hooks/fragments';

export type DeleteCustomPacingError = {
  id: string;
  message: string;
  errorCode?: string | null;
};

export const ERROR_MESSAGE = 'Errors occurred while deleting custom pacings';

export const handleDeleteCustomPacingErrors = (errors: DeleteCustomPacingError[]): void => {
  const resultDescription = errors.reduce((acc, error): string => {
    const errorCodeText = error.errorCode ? `- ${error.errorCode} ` : '';

    const message = `Line Item Id: ${error.id} ${errorCodeText}- ${error.message}\r\n`;

    return (acc += message);
  }, '');

  openErrorToastAlert(resultDescription, ERROR_MESSAGE);
};

export const handleDeleteCustomPacingCacheUpdate = (
  cache: ApolloCache<DeleteLineItemCustomPacingV5Mutation>,
  customPacingResponse: DeleteLineItemCustomPacingV5Mutation['deleteLineItemCustomPacingV5'][0]
): void => {
  const { cacheData, cacheId } = getOldCacheData<LineItemV5>({
    cacheIdPrefix: CacheEntityIdentifier.LineItemV5,
    id: customPacingResponse.lineItemId,
    fragment: LINE_ITEM_TRAFFICKING_COLUMNS,
  });

  cache.writeFragment({
    id: cacheId,
    fragment: LINE_ITEM_TRAFFICKING_COLUMNS,
    data: {
      ...cacheData,
      schedule: customPacingResponse.lineItem?.schedule,
      customPacingApplied: customPacingResponse.lineItem?.customPacingApplied,
    },
  });
};

export const showSuccessDeleteCustomPacingMessage = (updatedLineItemsAmount: number): void => {
  openToastAlert({
    alertType: AlertType.SUCCESS,
    message: `You have successfully removed the Custom Pacing Schedules from ${updatedLineItemsAmount} Line Item(s).`,
  });
};
